import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import BenefitInfoComponent from './components/BenefitInfo/BenefitInfo';
import BenefitsComponent from './components/Benefits/Benefits';
import CouponBenefitComponent from './components/CouponBenefit/CouponBenefit';
import CreateAccountComponent from './components/CreateAccount/CreateAccount';
import CreateModalComponent from './components/CreateModal/CreateModal';
import DashboardComponent from './components/Dashboard/Dashboard';
import AppSpinner from './components/Extras/AppSpinner/AppSpinner';
import HomeComponent from './components/Home/Home';
import LoginContainerComponent from './components/Login/LoginContainer';
import NavbarMain from './components/Navbar/Navbar';
import PaymentLandingComponent from './components/PaymentLanding/PaymentLanding';
import ProductComponent from './components/Product/Product';
import ShoppingCart from './components/ShoppingCart/ShoppingCart';
import StoreComponent from './components/Store/Store';
import Chat from './components/Chat/Chat';
import RecoverPasswordComponent from './components/PasswordReset/RecoverPassword';
import ResetPasswordComponent from './components/PasswordReset/ResetPassword';
import { setUser, userLogin } from './redux/modules/auth';
import { setShowShoppingCart } from './redux/modules/show';
import { setChatNotification } from './redux/modules/chat';
import { apiUrl, businessName, businessUserType1 } from './utils/consts';
import { getFromStorage } from './utils/storage';
import './App.scss';

const select = state => {
  return {
    authenticated: state.auth.authenticated,
    user: state.auth.user,
    userId: state.auth.userId,
    token: state.auth.token,
    updateUserInfo: state.auth.updateUserInfo,
    showShoppingCart: state.show.showShoppingCart
  };
};

function mapDispatchToProps(dispatch) {
  return {
    userLogin: payload => dispatch(userLogin(payload)),
    setUser: payload => dispatch(setUser(payload)),
    setShowShoppingCart: show => dispatch(setShowShoppingCart(show)),
    setChatNotification: show => dispatch(setChatNotification(show))
  };
}

function ConnectedApp(props) {

  const { authenticated, showShoppingCart, userId } = props;
  const [loading, setLoading] = useState(true);
  const isUserType1 = props.user && props.user.nibiBusinessUserType === businessUserType1;

  useEffect(() => {
    checkToken();
  }, []);

  useEffect(() => {
    if (authenticated && userId) {
      fetch(`${apiUrl}/chat/has_new_message/${userId}`)
        .then(resp => resp.json())
        .then(chatResp => {
          if (chatResp.success && chatResp.chats > 0) {
            const { chats } = chatResp;
            props.setChatNotification({
              showNotifications: true, number: chats > 9 ? '+9' : chats
            });
          }
        });
    }
  }, [authenticated]);

  useEffect(() => {
    if (props.updateUserInfo) getUserInfo();
  }, [props.updateUserInfo]);

  const getUserInfo = async () => {

    const userProm = await fetch(`${apiUrl}/users/get/info`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        token: props.token,
        userId: props.userId,
        businessName
      })
    });

    const userJson = await userProm.json();
    if (userJson.success) props.setUser({ user: userJson.user });
  };

  const checkToken = async () => {
    const obj = getFromStorage('nibi_business_app');

    if (obj && obj.token) {
      const { token } = obj;

      const loginProm = await fetch(`${apiUrl}/users/verify_token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token,
          businessName
        })
      });

      const loginResp = await loginProm.json();

      if (loginResp.success) {
        const { user, userId } = loginResp;
        props.userLogin({ user, userId, token });
      }
    }

    setLoading(false);
  };

  return (
    <div className="App">
      {
        loading ?
        <AppSpinner /> :
        <Router>
          <NavbarMain />
          {
            authenticated &&
            <>
              <CreateModalComponent />
              <OverlayTrigger placement="top" overlay={<Tooltip>Soporte</Tooltip>}>
                <a id="chatButton" target="_blank" rel="noopener noreferrer" href="https://wa.me/573052448597?text=Necesito%20ayuda%20con%20la%20plataforma%20solidaria%20Cemex">
                  <i className="fa fa-whatsapp" style={{ marginTop: "16px" }} />
                </a>
              </OverlayTrigger>
              <div className="cartPanel" style={showShoppingCart ? { width: '45%' } : { width: '0px' }}>
                {showShoppingCart && <ShoppingCart />}
              </div>
              <div onClick={() => props.setShowShoppingCart(false)} className="cartOverlay" style={showShoppingCart ? { display: 'block' } : { display: 'none' }} />
            </>
          }
          {
            !authenticated ?
            <Switch>
              <Route path="/crear_cuenta" component={CreateAccountComponent} />
              <Route path="/recuperar_contrasenia" component={RecoverPasswordComponent} />
              <Route path="/reestablecer_contrasenia" component={ResetPasswordComponent} />
              <Route path="/" component={LoginContainerComponent} />
            </Switch> :
            <Switch>
              <Route path={["/", "/home"]} exact component={HomeComponent} />
              <Route path="/tienda" component={StoreComponent} />
              {
                isUserType1 &&
                <Route path="/seccion_solidaria" component={BenefitsComponent} />
              }
              <Route path="/productos/:id" component={ProductComponent} />
              <Route path="/ayudas/bono/:id" component={CouponBenefitComponent} />
              <Route path="/ayudas/:id" component={BenefitInfoComponent} />
              <Route path="/carrito" component={ShoppingCart} />
              <Route path="/pago/resultado" component={PaymentLandingComponent} />
              <Route path="/dashboard" component={DashboardComponent} />
              <Route path="/chat" component={Chat} />
            </Switch>
          }
        </Router>
      }
    </div>
  );
}

const App = connect(select, mapDispatchToProps)(ConnectedApp);

export default App;
